import { gql } from '@apollo/client'

export const PublishStatusChangeSubscription = gql`
    subscription PublishStatusChange($instanceId: String!) {
        onPublishStatusChange(instanceId: $instanceId) {
            downloadURL
            firmId
            projectId
            status
            faultyFamilies
            errorMessage
        }
    }
`

export const ProductFamilyPublishResultChangeSubscription = gql`
    subscription onProductFamilyPublishResultChange($instanceId: String!) {
        onProductFamilyPublishResultChange(instanceId: $instanceId) {
            firmId
            projectId
            status
            errorMessage
            instanceId
            productFamilyPublishResults {
                productFamilyId
                status
                errorMessage
            }
        }
    }
`
